module.exports = __webpack_public_path__ + "static/roboto-mono-v7-latin-500-3f107f0a4cf59cba836c6cad6b76c224.woff";